import React from "react";
import { useState } from "react";

export default function InsertImage({ setSelectedImage }) {
    const handleInsertImage = (event) => {
      const file = event.target.files[0];
      if (file && file.type.includes("image")) {
        setSelectedImage(URL.createObjectURL(file));
      }
    };
  
    return <input type="file" accept="image/*" onChange={handleInsertImage} />;
  }